//features/auth/RequireAuth.js
import { useLocation, Navigate, Outlet } from "react-router-dom"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation()
    const { roles, isLoading } = useAuth()  // ← Giả sử useAuth có isLoading (nếu không, thêm vào)

    // Nếu auth đang loading → chờ (tránh redirect sớm)
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-dark">
                <PulseLoader color="#FFF" size={15} />
            </div>
        )
    }

    // Nếu roles chưa có (token null hoặc chưa verify) → về login
    if (!roles || roles.length === 0) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    // Kiểm tra quyền
    const hasPermission = roles.some(role => allowedRoles.includes(role))

    return hasPermission ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
}

export default RequireAuth